import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Ctx = createContext(null);

export const CATEGORIES = [
  { id: "todos", label: "Todo", color: "bg-kyellow" },
  { id: "utiles_escolares", label: "Útiles Escolares", color: "bg-kcyan" },
  { id: "agendas", label: "Agendas & Planners", color: "bg-kpink" },
  { id: "regalos", label: "Regalos & Novedades", color: "bg-kpurple" },
  { id: "papeleria_creativa", label: "Papelería Creativa", color: "bg-korange" },
];

export function StoreProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [cart, setCart] = useState([]);
  const [user, setUser] = useState(null);

  const fetchProducts = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/products`);
      setProducts(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingProducts(false);
    }
  }, []);

  useEffect(() => { fetchProducts(); }, [fetchProducts]);

  useEffect(() => {
    axios.get(`${API}/auth/me`, { withCredentials: true })
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  const addToCart = (p) => {
    setCart((prev) => {
      const found = prev.find((i) => i.id === p.id);
      if (found) return prev.map((i) => (i.id === p.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { id: p.id, name: p.name, price: p.price, qty: 1 }];
    });
    toast.success(`${p.name} agregado a tu pedido`);
  };

  const removeFromCart = (id) => setCart((prev) => prev.filter((i) => i.id !== id));
  const updateQty = (id, qty) =>
    setCart((prev) =>
      qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))
    );
  const clearCart = () => setCart([]);

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const cartTotal = cart.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <Ctx.Provider value={{
      products, loadingProducts, fetchProducts,
      cart, addToCart, removeFromCart, updateQty, clearCart, cartCount, cartTotal,
      user, setUser,
    }}>
      {children}
    </Ctx.Provider>
  );
}

export const useStore = () => useContext(Ctx);
